import { Component, OnInit } from '@angular/core';
import { UserService } from '@/core/services/open-api/user.service';

@Component({
    selector: 'app-share',
    templateUrl: './share.component.html',
    styleUrls: ['./share.component.scss'],
    standalone: false,
})
export class ShareComponent implements OnInit {
    shareFriendsCopylink?: string;
    displayBasic: boolean = false;

    constructor(private readonly userService: UserService) {
        this.userService.currentUser$.subscribe((user) => {
            if (user) {
                this.shareFriendsCopylink = 'https://timebuzzer.com/?ref=account_' + user.accountId;
            }
        });
    }

    ngOnInit(): void {
        // Empty
    }

    redirectAffiliate(): void {
        this.userService.getLicensesURL().subscribe((data) => {
            const domain = data.split('?');
            const newUrl = domain[0] + '/affiliate-area/' + '?' + domain[1];
            window.open(newUrl, '_self');
        });
    }

    shareEmail(): void {
        window.open(
            'mailto:?subject=Check%20out%20timeBuzzer&body=Hey!%0D%0A%0D%0AI%20recently%20discovered%20timeBuzzer%20and%20thought%20you%20might%20be%20interested%20too.%0D%0A%0D%0AIt%20is%20an%20incredibly%20simple%20and%20smooth%20time%20tracking%20software%20with%20an%20optional%20hardware%20button%20for%20the%20desktop.%20%0D%0AIt%20helps%20to%20effortlessly%20track%20time%20while%20you%20work%20and%20saves%20the%20hassle%20of%20estimating%20at%20the%20end%20of%20the%20week%20%3A)%0D%0A%0D%0ACheck%20out%20their%20website%3A%20https%3A%2F%2Ftimebuzzer.com%2F%0D%0A%0D%0ABest%20regards',
            '_self',
        );
    }

    shareWhatsapp(): void {
        window.open(
            'https://wa.me/?text=Hey,%20I%20recently%20discovered%20timeBuzzer%20and%20thought%20you%20might%20be%20interested%20too!',
            '_blank',
            'noopener',
        );
    }

    shareTwitter(): void {
        window.open(
            'https://twitter.com/intent/tweet/?text=I%20recently%20discovered%20%40timeBuzzer%20and%20thought%20you%20might%20be%20interested%20too!',
            '_blank',
            'noopener',
        );
    }

    shareReddit(): void {
        window.open(
            'https://www.reddit.com/submit?url=https%3A%2F%2Ftimebuzzer.com%2F&title=Incredible%20smooth%20time%20tracking!',
            '_blank',
            'noopener',
        );
    }

    shareFacebook(): void {
        window.open('https://facebook.com/sharer/sharer.php?u=https%3A%2F%2Ftimebuzzer.com', '_blank', 'noopener');
    }

    shareLinkedIn(): void {
        window.open(
            'https://www.linkedin.com/shareArticle?mini=false&url=https://timebuzzer.com/',
            '_blank',
            'noopener',
        );
    }
}
